// GET /data/molecule/{bsadbId}
//
// `moleculeDetails.items` is a small, fixed set of {key, value} pairs the
// hero card looks up by well-known key — NOT a generic label/value list like
// the other three sections. The two keys the page currently recognizes:
export const MOLECULE_DETAIL_ID_KEY = "bsadb_id";
export const MOLECULE_DETAIL_SMILES_KEY = "smiles";

export interface IMoleculeDetailItem {
  key: string;
  value: string;
}

export interface IMoleculeDetailsSection {
  displayName: string;
  items: IMoleculeDetailItem[];
}

export interface IMoleculePropertyItem {
  displayName: string;
  value: string;
}

export interface IMoleculePropertiesSection {
  displayName: string;
  items: IMoleculePropertyItem[];
}

export interface IMoleculeInformationItem {
  displayName: string;
  value: string[];
}

export interface IMoleculeInformationSection {
  displayName: string;
  items: IMoleculeInformationItem[];
}

/** value/url are null when this molecule has no id for that database. */
export interface IMoleculeExternalDBItem {
  displayName: string;
  value: string | null;
  url: string | null;
}

export interface IMoleculeExternalDBsSection {
  displayName: string;
  items: IMoleculeExternalDBItem[];
}

export interface IGetMoleculeDetailsResponse {
  moleculeDetails: IMoleculeDetailsSection;
  properties: IMoleculePropertiesSection;
  moleculeInformation: IMoleculeInformationSection;
  externalDBs: IMoleculeExternalDBsSection;
}
